import type { OverlayHookImageVariant, OverlayHookVariant } from "../types/types";

export const IMAGE_BY_VARIANT: Record<OverlayHookVariant, OverlayHookImageVariant> = {
    horizontal: {
        src: "/images/gain-access-lock.svg",
        width: 212,
    },
    vertical: {
        src: "/images/get-all-hook.svg",
        width: 249,
    },
};
